class EventLogModel extends App.Models.BaseModel {

    modelUrl = 'EventLog';

    fetchWithCriteria = (obj) => {
        return Monet.Model.fetchWithCriteria({
            options: obj,
            model: this
        });
    }

    searchAllWithCriteria = (obj) => {
        return Monet.Model.searchAllWithCriteria({
            options: obj,
            model: this
        });
    }

    filterWithRestrictions = (obj) => {
        return Monet.Model.filterWithRestrictions({
            options: obj,
            model: this,
            body: obj.body
        });
    }

    findAndLock = (obj) => {
        return Monet.Model.filterWithRestrictions({
            options: obj,
            model: this,
            restrictionUrl: '/FindAndLock',
            body: obj.body
        });
    }

    getMessageEventLogLocked = ({ key, parameters: { currentOwner, currentOpenedWhen } }) => {
        const translatedMessage = Monet.I18n.getResourcesByKey(key);
        if (currentOwner) {
            const currentOwnerKey = currentOwner.match(/key=(.+)/)[1].split(/,|]/)[0];
            const openedWhen = Monet.Format.DateTime.formatToLocale(currentOpenedWhen + '+0000');
            return translatedMessage.replace('{currentOpenedWhen}', openedWhen)
                .replace('{currentOwner}', currentOwnerKey);
        }
        return translatedMessage;
    }

    releaseEventLog = () => {
        const eventId = parseInt(this.id);
        const tabName = this.tabName;
        const blockedEventTabs = Monet.Session.EventLog.blockedEventTabs[eventId];
        if (blockedEventTabs) {
            const index = blockedEventTabs.indexOf(tabName);
            index !== -1 && blockedEventTabs.splice(index, 1);
            const blockedEventTabsSize = blockedEventTabs.length;

            if (this.currentIdLocked && !blockedEventTabsSize) {
                const tabRouter = App.Objects[Monet.Utils.GetTabName()];
                const ajax = new Monet.Ajax();
                ajax.url = `EventLog/ReleaseEventLogOpenedByLock/${this.currentIdLocked}`;
                ajax.method = 'GET';
                ajax.async = false;
                ajax.success = () => {
                    tabRouter && tabRouter.removeCloseAction && tabRouter.removeCloseAction(this.releaseEventLog.bind(this));
                    console.log(`EventLog ${this.currentIdLocked} was released.`);
                    this.currentIdLocked = null;
                    const eventIdIndex = Monet.Session.EventLog.blockedEventIds.indexOf(eventId);
                    if (eventIdIndex !== -1) Monet.Session.EventLog.blockedEventIds.splice(eventIdIndex, 1);
                };
                ajax.error = data => {
                    console.log(`EventLog ${this.currentIdLocked} could not be released.`, data);
                };
                ajax.send();
            }
        }
    }

    getDataAndOpenPopup = (openPopupCallback, currentOwner) => {
        this.initializeMonetSession();
        const tabRouter = App.Objects[Monet.Utils.GetTabName()];
        const eventId = parseInt(this.id);
        const body = { eventLogId: eventId };
        if (currentOwner) {
            body.currentOwner = { id: currentOwner };
        }

        const options = {
            criteria: Greenmile.EventLog.Util.criteria,
            body: JSON.stringify(body),
            success: (data) => {
                const isEventClosed = data && data.attributes.closed;
                if (isEventClosed) {
                    const realData = data.attributes;
                    const solvedWhen = Monet.Format.DateTime.formatToLocale(realData.solvedWhen);
                    const message = Monet.I18n
                        .getResourcesByKey('EventNotification.eventIsAlreadyClosed')
                        .replace('{solvedBy}', realData.solvedBy.name)
                        .replace('{solvedWhen}', solvedWhen);

                    new Greenmile.Components.AlertModal(message)
                        .show();
                }
                this.currentIdLocked = eventId;
                this.addToLockedScreens();

                if(!Monet.Session.EventLog.blockedEventIds.includes(eventId)) {
                    Monet.Session.EventLog.blockedEventIds.push(eventId);
                    console.log(`EventLog ${this.currentIdLocked} was locked.`);
                }

                this.tabName = Monet.Utils.GetTabName();
                tabRouter && tabRouter.addCloseAction && tabRouter.addCloseAction(this.releaseEventLog.bind(this));
                const enableCloseButton = () => {
                    const closeEventButton = document.querySelector(`.EventWindow.EventWindow-${eventId} input[name="closeButton"]`);

                    if (closeEventButton && !isEventClosed) {
                      closeEventButton.removeAttribute('disabled');
                    } else if (closeEventButton) {
                      closeEventButton.setAttribute('disabled', 'true');
                    }
                }
                openPopupCallback(data, enableCloseButton);
            },
            error: (e) => {
                if (e.status === 409) {
                    const errorMessage = JSON.parse(e.responseText).errorMessages;

                    const getDataAndOpenPopupAction = () => {
                        const currentOwnerId = errorMessage[0].resource.parameters.currentOwner.match(/id=(.+)/)[1].split(/,|]/)[0];
                        this.getDataAndOpenPopup(openPopupCallback, currentOwnerId);
                    };

                    const disableCloseButtonAction = () => {
                        const disableCloseButton = () => {
                            let tab = Monet.Utils.GetTabName();
                            const closeEventButton = document.querySelector(`#${tab} .EventWindow.EventWindow-${eventId} input[name="closeButton"]`);
                            if (closeEventButton) {
                                closeEventButton.setAttribute('disabled', true);
                            }
                        };
                        openPopupCallback(e, disableCloseButton);
                    };

                    new Greenmile.Components.AlertModal(this.getMessageEventLogLocked(errorMessage[0].resource),
                        null,
                        getDataAndOpenPopupAction,
                        disableCloseButtonAction)
                    .show();

                } else {
                    Monet.Tooltip.hideTooltip(Monet.Session.WindowNotification.selector);
                }
            }
        };

        this.findAndLock(options);
    }

    initializeMonetSession = () => {
        Monet.Session = Monet.Session || {};
        Monet.Session.EventLog = Monet.Session.EventLog || {
            blockedEventTabs: {},
            blockedEventIds: []
        };
    }

    addToLockedScreens = () => {
        const tabName = Monet.Utils.GetTabName();
        const eventId = this.id;

        Monet.Session.EventLog.blockedEventTabs[eventId] = Monet.Session.EventLog.blockedEventTabs[eventId] || [];
        Monet.Session.EventLog.blockedEventTabs[eventId].push(tabName);
    }
}

App.Models.EventLog = EventLogModel;
